import React from 'react';
import PropTypes from 'prop-types';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from './styles';

export function SelectAllButton({ content, onClick, disabled }) {
  return (
    <CPButton
      onClick={onClick}
      disabled={disabled}
      content={content}
      icon={faCheckSquare}
    />
  );
}

SelectAllButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

SelectAllButton.defaultProps = {
  onClick: () => null,
  content: 'Обрати всі',
  disabled: false,
};

export default SelectAllButton;
